module.exports = __webpack_public_path__ + "static/media/logo-seplag.c4dbf865.png";